export default __webpack_public_path__ + "static/media/empty_image.32e15724.svg";